import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';

import './novaSati.css';
import verificandoToken from '../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../FuncoesGerais/verificaApp';
import filtrarUsuarioIA from '../../FuncoesGerais/filtrarUsuarioIA';
import { ensureProtocol } from '../../config/backend';
import { useTiposChamado } from '../../hooks/useTiposChamado';
import ChamadoCreatePageAnalista from './components/ChamadoCreatePageAnalista';

function NovaSati() {

    const history = useHistory();
    const { tipos } = useTiposChamado();

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    const [numero, setNumero] = useState('');
    const [satDesSaius, setSatDesSai] = useState('');
    const [satEmlSolus, setSatEmlSol] = useState('');
    const [sucesso, setSucesso] = useState('N');
    const [mensagem, setMensagem] = useState('');
    const [satEml, setSatEml] = useState('');
    const [data, setData] = useState([]);
    const [listSistemas, setListSistemas] = useState([]);
    const [listaEquipamento, setListaEquipamento] = useState([]);
    const [selected, setSelected] = useState("");
    const [satAreSol, setSatAreSol] = useState('');
    const [codSis, setCodSis] = useState("0");
    const [codEqp, setCodEqp] = useState("0");
    const [satTip, setSatTip] = useState("");
    const [imagemAbertura, setImagemAbertura] = useState(null);
    const [nomeImagemAbertura, setNomeImagemAbertura] = useState("");
    const [salvando, setSalvando] = useState(false);

    const retornaNumero = async () => {

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis/proxima", {
                headers: {
                    Authorization: `${token}`
                }
            });

            setNumero(response.data.length > 0 ? response.data[0].PROX : '')

        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    useEffect(() => {
        verificar();
        retornaNumero();
        pegarUsuarios();
        pegarSistemas();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const pegarUsuarios = async (e) => {

        let listaNomes = [];

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios/ativos", {
                headers: {
                    Authorization: `${token}`
                }
            });
            const raw = filtrarUsuarioIA(Array.isArray(response.data) ? response.data : [], 'USRNOMCPL');
            let i = 0;
            while (i < raw.length) {
                listaNomes.push({
                    nome: raw[i].USRNOMCPL,
                    sequencia: raw[i].USUSEQ,
                    USREML: raw[i].USREML,
                    USRLGN: raw[i].USRLGN,
                });
                i++;
            }
            setData(listaNomes);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarSistemas = async (e) => {

        let listaSistemas = [];

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/sistemas/ativos", {
                headers: {
                    Authorization: `${token}`
                },
                params: {
                    descr: " "
                }
            });
            let i = 0;

            while (i < response.data.length) {
                const r = response.data[i];
                const cod = r.CODSIS ?? r.codsis;
                const nom = r.NOMSIS ?? r.nomsis ?? '';
                listaSistemas.push({
                    codsis: cod,
                    nomsis: nom
                });
                i++;
            }
            setListSistemas(listaSistemas);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarEquipamento = async (cod) => {
        let listEqp = [];

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/vinculacao/vincUsuarios", {
                headers: {
                    Authorization: `${token}`
                },
                params: {
                    codUsu: cod
                }
            });
            let i = 0;

            while (i < response.data.length) {

                listEqp.push({
                    codhar: response.data[i].CODEQP,
                    nomeqp: response.data[i].NOMEQP,
                    sereqp: response.data[i].SEREQP,
                    pateqp: response.data[i].PATEQP
                })
                i++;
            }
            setListaEquipamento(listEqp);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarEmail = async (codUsu) => {

        let solicitante = codUsu;
        let eml = "";

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/usuarios/solicitante", {
                headers: {
                    Authorization: `${token}`
                }, params: {
                    solicitante: solicitante
                }
            });

            eml = response.data[0].USREML;
            setSatEml(eml);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        let erro = 'OK';

        if (!selected || String(selected).trim() === '') {
            setMensagem('Selecione o solicitante!');
            erro = 'S';
        } else if (satAreSol !== "I" && satAreSol !== "S") {
            setMensagem('Selecionar o setor!');
            erro = 'S';
        } else if (satDesSaius.trim().length === 0) {
            setMensagem('Preencher descrição!');
            erro = 'S';
        } else if (!satTip || String(satTip).trim() === '') {
            setMensagem('Selecione o tipo do chamado!');
            erro = 'S';
        }

        if (erro === 'S') return;

        const codUsu = selected;
        const satDesSai = satDesSaius;
        const satAte = 1;
        const satEmlSol = (satEml != null && satEml !== '' ? satEml : '') + (satEmlSolus && satEmlSolus.trim() ? ';' + satEmlSolus.trim() : '');

        verificandoToken();
        const token = localStorage.getItem('token');

        setSalvando(true);
        setMensagem('');
        try {
            const codUsuNum = Number(codUsu);
            const satTipNum = parseInt(satTip, 10);
            const codSisVal = (codSis === '0' || codSis === '' || codSis == null) ? undefined : codSis;
            const codEqpVal = (codEqp === '0' || codEqp === '' || codEqp == null) ? undefined : (parseInt(codEqp, 10) || codEqp);
            const body = {
                satDesSai,
                codUsu: !Number.isNaN(codUsuNum) ? codUsuNum : codUsu,
                satEmlSol: satEmlSol || '',
                satAte: Number(satAte) || 1,
                satTip: !Number.isNaN(satTipNum) ? satTipNum : satTip,
                satAreSol: satAreSol || ''
            };
            if (codSisVal !== undefined) body.codSis = codSisVal;
            if (codEqpVal !== undefined) body.codEqp = codEqpVal;

            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/satis",
                body,
                { headers: { Authorization: `${token}` } });

            let mensagemAnexo = '';
            if (imagemAbertura && nomeImagemAbertura) {
                try {
                    await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/anexos",
                        { satNum: numero, nomArq: nomeImagemAbertura, Arquivo64: imagemAbertura },
                        { headers: { Authorization: `${localStorage.getItem('token')}` } });
                } catch (errImg) {
                    console.error('Anexo de imagem na abertura:', errImg);
                    mensagemAnexo = 'Chamado criado, mas o anexo não foi gravado. Anexe depois na tela do chamado.';
                }
            }

            if (codEqp !== "0") {
                try {
                    await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                        { codHar: codEqp, desHis: `Abertura de chamado - ${numero} \n\nPara tratamento do hardware.` },
                        { headers: { Authorization: `${localStorage.getItem('token')}` } });
                } catch (errHw) {
                    setMensagem('Erro ao registrar histórico de hardware.');
                    setSucesso('N');
                }
            }

            setMensagem(mensagemAnexo);
            setSucesso('S');
        } catch (error) {
            console.error('Erro ao inserir dados:', error);
            const msgBackend = error.response?.data?.message || error.response?.data?.error || (typeof error.response?.data === 'string' ? error.response.data : null);
            const detalhe = msgBackend ? `: ${msgBackend}` : (error.response?.data ? `: ${JSON.stringify(error.response.data)}` : '');
            setMensagem('Erro ao inserir dados' + detalhe);
            setSucesso('N');
        } finally {
            setSalvando(false);
        }
    };

    const handleSolicitanteChange = (val) => {
        setSelected(val);
        pegarEmail(val);
        pegarEquipamento(val);
    };

    const handleAnexoChange = ({ base64, nome }) => {
        setImagemAbertura(base64);
        setNomeImagemAbertura(nome || '');
    };

    return (
        <ChamadoCreatePageAnalista
            numero={numero}
            selected={selected}
            onSolicitanteChange={handleSolicitanteChange}
            data={data}
            descricao={satDesSaius}
            setDescricao={setSatDesSai}
            tipo={satTip}
            setTipo={setSatTip}
            setor={satAreSol}
            setSetor={setSatAreSol}
            codSis={codSis}
            setCodSis={setCodSis}
            codEqp={codEqp}
            setCodEqp={setCodEqp}
            listSistemas={listSistemas}
            listaEquipamento={listaEquipamento}
            tipos={tipos}
            emailAdicional={satEmlSolus}
            setEmailAdicional={setSatEmlSol}
            nomeAnexo={nomeImagemAbertura}
            onAnexoChange={handleAnexoChange}
            onSubmit={handleSubmit}
            salvando={salvando}
            mensagem={mensagem}
            sucesso={sucesso}
        />
    );
}

export default NovaSati;  